import { CellText } from '@increasecard/typed-components';
import styled from 'styled-components';

// TODO: add this component to typed-components
export const LabelError = styled(CellText)`
  color: var(--color-coralAlert-regular);
`;
